'use client'

import { AddToCartButton, FreeDownloadButton } from '@/AddToCartButton'
import { Button } from '@/General/Button'

export const ButtonRow = ({
  productId,
  url,
  name,
  productType,
  additionalButtons,
  options,
  isFreeDownload = false,
  productSlug,
  hasDownloads = false,
  primaryAction = 'more-info',
}: ButtonRowProps) => {
  const isDeckOfCards = productType.toLowerCase() === 'deck of cards'
  const moreInfoButton = url ? (
    <Button
      href={url}
      title={`More about ${name}`}
      color="dark"
      size="sm"
      data-product-link
    >
      More Info
    </Button>
  ) : null
  const cartButton = (
    <div className="flex items-center">
      {isFreeDownload && productSlug ? (
        <FreeDownloadButton
          productSlug={productSlug}
          productName={name}
          size="sm"
          className=""
        />
      ) : (
        <>
          <AddToCartButton
            productId={productId}
            productName={name}
            options={options}
            isDeckOfCards={isDeckOfCards}
            hasDownloads={hasDownloads}
            buttonSize="sm"
          />
          {options.length > 0 && options.every(option => !option.inStock) && (
            <span className="text-sm text-gray-500">Out of Stock</span>
          )}
        </>
      )}
    </div>
  )

  return (
    <div className="mt-4 flex flex-wrap gap-2 justify-start items-center">
      {primaryAction === 'add-to-cart' ? (
        <>
          {cartButton}
          {moreInfoButton}
        </>
      ) : (
        <>
          {moreInfoButton}
          {cartButton}
        </>
      )}
      {additionalButtons && (
        <div className="inline-block">{additionalButtons}</div>
      )}
    </div>
  )
}

interface ButtonRowProps {
  productId: number
  url?: string
  name: string
  productType: string
  additionalButtons?: React.ReactNode
  isFreeDownload?: boolean
  productSlug?: string
  hasDownloads?: boolean
  primaryAction?: 'more-info' | 'add-to-cart'
  options: {
    id: number
    description: string
    price: number
    salePrice: number
    currencySymbol: string
    inStock: boolean
    productType: string
    needsShipping: boolean
  }[]
}
